import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { FooterResource } from 'app/models/FooterResource';
import { FooterUsefulContactsResource } from 'app/models/FooterUsefulContactsResource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'vbn-useful-contacts',
  templateUrl: './useful-contacts.component.html',
  styleUrls: ['./useful-contacts.component.scss']
})
export class UsefulContactsComponent implements OnInit {

  selected_language: string;
  usefulC: FooterUsefulContactsResource;
  usefulCRid : any;
  addressParams: any;
  errorMessage: any;
  userEmail: string;
  validationForm: FormGroup;
  saveErrors: boolean = false;
  footerRid: any;

  constructor(private router: Router, 
    private activatedRoute: ActivatedRoute,
    private service: UtilsService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private _notificationService: NotificationsService) {

      this.selected_language = "ro";
      this.usefulC = new FooterUsefulContactsResource();
     }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    if(this.router.url != '/add-useful-contacts') {
      
      this.activatedRoute.params.subscribe((params: Params) => {
        
          this.addressParams = JSON.parse(atob(params['json']));
          console.log("====>>>> add useful contact = ", this.addressParams )
          this.usefulCRid = this.addressParams.usefulCRid;
          this.footerRid = this.addressParams.footerRid;
          if(this.usefulCRid){
            this.getUsefulContactByRid(this.usefulCRid);
          }
        
      });
    }

    this.validationForm = this.fb.group({
      nameRo:['', [Validators.required, Validators.maxLength(50), Validators.minLength(3)]],
      nameEn:[''],
      nameFr:[''],
      nameDe:[''],
      contact:['', [Validators.required,  Validators.minLength(3), Validators.maxLength(50),]],
    
    })
  }

  getUsefulContactByRid(rid) {

    this.service.get(`/admin/footer/getOneUsefulContact/${rid}`)
      .subscribe(
        response => {
          this.usefulC = response;
          if([9112, 9113].indexOf(this.usefulC.errorCode) > 0){
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`No useful contact`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }
        },
        error => this.errorMessage = <any>error);
  }

  save(){
    if(!this.validationForm.valid){
      this.saveErrors = true;
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Required fields`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      return;
    }

    if ( !this.usefulC.footerResource){
      this.usefulC.footerResource = new FooterResource();
      this.usefulC.footerResource.userEmail = this.userEmail;
      this.usefulC.footerResource.rid = this.footerRid;

    } 
    this.service.add('/admin/footer/addFooterUsefulContact', this.usefulC)
      .subscribe(
        response => {
          this.usefulC = response;
          if(this.usefulC.errorCode === 9115 ){
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`Client does not exist!`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }else{
            if(this.usefulC.errorCode === 9114 ){
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Name is required`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            }else{
              if(this.usefulC.errorCode === 9116){
                  forkJoin(
                    [this.translate.get('Error'),
                    this.translate.get(`Contact is required`)]
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'error')
                  })
              }else{
                  if(this.usefulCRid) {
                    forkJoin(
                      [this.translate.get('Success'),
                      this.translate.get('Useful contact was successfully edited!')]
                    ).subscribe((res) => {
                      this._notificationService.create(res[0], res[1], 'success')
                    });
                  } else {
                    forkJoin(
                      [this.translate.get('Success'),
                      this.translate.get('Useful contact was successfully created!')]
                    ).subscribe((res) => {
                      this._notificationService.create(res[0], res[1], 'success')
                    });
                  }
                  this.back();
              }
            }
          }
          
          
        },
        error => this.errorMessage = <any>error);
  }

  back() {
    this.router.navigate(['/edit-footer/' + btoa('{ "footerRid" : "' + this.footerRid + '"}')]);
  }
}
